module.exports = __webpack_public_path__ + "img/img_1@2x.e51cde94.svg";